<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="10090301">
        <el-button type="primary" plain @click="toEdit()">新增配件类型</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
            >
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions:  '10090302',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                 {
                    permpisions: '10090303',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import { getInventoryModelList, deleteInventoryModelById} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'accessoryName', label: '配件名称' },
          { prop: 'accessoryModel', label: '型号' },
          { prop: 'unit', label: '计量单位' },
          { prop: 'remarks', label: '备注' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getInventoryModelList,
    toEdit (item) {
      this.jump({
        label: (item && item.id ? '修改' : '新增') + '配件类型',
        url: `/manage/service/inventoryManagement/accessoryType/edit${item && item.id ? '?id=' + item.id : ''}`,
        full: true,
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除型号为【${item.accessoryModel}】的【${item.accessoryName}】吗?`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await deleteInventoryModelById({
          id: item.id,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
